module.exports = __webpack_public_path__ + "images/help/icon-twr29-de375c683517c5da3a35cb715698df15.png";